export default "__VITE_ASSET__BsNAgJlH__"